import { IORGDataTableQueryState } from 'shared-it-appmod-ui';
import { httpClient } from 'src/libraries/http.library';
import { ChangeLogsSchema } from 'src/models/change-log.model';

const http = httpClient();

const changeLogService = {
  changeLogGET: async (
    id: number,
    data: Partial<IORGDataTableQueryState> = {}
  ) => {
    const params: Record<string, any> = {
      ...data,
    };
    if (params.order) {
      params.order = params.order === 'ascending' ? 'asc' : 'desc';
    }
    return http.get(`changelog/${id}`, params, ChangeLogsSchema);
  },
};

export default changeLogService;
